import { SharedBusinessEntity } from "../shared/_config/api/shared-business-entity";
import { ApiSharedMethod } from "./api-methods.shared";
import { MapSharedDelivery } from "./shared-delivery/shared-delivery.map";
import { ExtSharedDeliveryQueryI } from "./shared-delivery/shared-delivery.query.ext";
import { SharedDeliveryI } from "./shared-delivery/shared-delivery.result.int";

export class ApiDelMethod<T1, T2>  extends ApiSharedMethod<T1, T2> {
    static readonly sharedDelivery = new ApiSharedMethod<SharedDeliveryI, ExtSharedDeliveryQueryI>(
        2,
        SharedBusinessEntity.delivery,
        null,
        MapSharedDelivery.mapResult,
        MapSharedDelivery.mapQuery,
    );
}